import { render, staticRenderFns } from "./MeasurementPortlet.vue?vue&type=template&id=49298702&"
import script from "./MeasurementPortlet.vue?vue&type=script&lang=js&"
export * from "./MeasurementPortlet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports